import React from 'react';
import PropTypes from 'prop-types';
import TooltipHOC from '../../../../shared/components/TooltipHOC/TooltipHOC';
import CustomReactMarkdown from '../../../../shared/components/MarkdownRenderers/CustomReactMarkdown';
import CaretIcon from '../../../../shared/icons/icon-caret.svg';
import ChevronIcon from '../../../../shared/icons/icon-chevron.svg';


class NavigationFlyout extends React.Component {
  constructor(props) {
    super(props);

    props.setConfig({
      alignMsg: 'left',
      title: 'Navigation',
      iconDimensions: 0,
      expandOnFocus: false,
    });
  }

  render() {
    const {
      navItem: {
        name,
        subGroups,
      },
      renderMsgBlock,
    } = this.props;

    return (
      <>
        <span className="navigation-flyout__trigger">
          {name}
          <ChevronIcon className="navigation-flyout__chevron" />
        </span>
        {renderMsgBlock((
          <span className="navigation-flyout">
            <CaretIcon className="navigation-flyout__caret" />
            {subGroups.map(subGroup => (
              <span
                className="navigation-flyout__subgroup"
                key={subGroup.name}
              >
                {subGroup.name && (
                  <span className="navigation-flyout__subgroup-title">{subGroup.name}</span>
                )}
                <ul className="navigation-flyout__link-list">
                  {subGroup.items.map(item => (
                    <li
                      className="navigation-flyout__link"
                      key={item}
                    >
                      <CustomReactMarkdown
                        key={item}
                        source={item}
                        noWrapper
                      />
                    </li>
                  ))}
                </ul>
              </span>
            ))}
            <span className="navigation-flyout__accent" />
          </span>
        ))}
      </>
    );
  }
}

NavigationFlyout.propTypes = {
  navItem: PropTypes.shape({
    name: PropTypes.string.isRequired,
    subGroups: PropTypes.arrayOf(PropTypes.shape({})),
  }).isRequired,
  renderMsgBlock: PropTypes.func.isRequired,
  setConfig: PropTypes.func.isRequired,
};

export default TooltipHOC(NavigationFlyout);
